/** 用户反馈关闭倒计时（ms） */
export const FEEDBACK_TIPS_CLOSE_TIME = 3000;
